export default __webpack_public_path__ + "static/media/affiche2011.22d890d4.png";